<script setup>
import { useI18n } from 'vue-i18n';
import SalesDetailManagerAddress from './SalesDetailManagerAddress.vue';
import SalesDetailManagerPersonal from './SalesDetailManagerPersonal.vue';

defineProps({ manager: { type: Object, default: null } });
const { t } = useI18n();
</script>

<template>
  <div
    v-if="!manager"
    class="rounded-lais border border-dashed border-lais-border bg-white p-8 text-center text-sm text-lais-text-muted"
  >
    {{ t('SALES.DETAIL.NO_MANAGER') }}
  </div>
  <div v-else class="grid gap-4">
    <SalesDetailManagerPersonal :manager="manager" />
    <SalesDetailManagerAddress :manager="manager" />
  </div>
</template>
